window.k1ScriptHome = {

	buttons: function () {
		let classificationTitles = [];
		document.querySelectorAll('.classification-chevron-js').forEach(chevron => {
			classificationTitles.push(chevron.closest(".main-classif__accardion-top"))
		})
		return classificationTitles;
	},
	makeClassificationHeight: function () {
		document.querySelectorAll('.classification-info-wrapper-js').forEach(item => {
			item.setAttribute('data-height', item.querySelector('.classification-info-js').clientHeight);
		})
	},
	openClassification: function (elem) {
		elem.closest('.main-classif__accardion').classList.add('opened');
		elem.querySelector(".classification-chevron-js").classList.add('opened');
		let infoBlock = elem.closest('.main-classif__accardion').querySelector('.classification-info-wrapper-js');
		infoBlock.style.maxHeight = infoBlock.getAttribute('data-height') + 'px';
	},
	closeClassification: function (elem) {
		elem.querySelector(".classification-chevron-js").classList.remove('opened');
		elem.closest('.main-classif__accardion').classList.remove('opened');
		let infoBlock = elem.closest('.main-classif__accardion').querySelector('.classification-info-wrapper-js');
		infoBlock.style.maxHeight = 0 + 'px';
	},
	getMobile: function () {
		return {
			main: document.querySelector('.content.main'),
			banner: document.querySelector('.head-banners'),
			filter: document.querySelector('.filter'),
			popular: document.querySelector('.filter__popular-bottom'),
			bigBanner: document.querySelector('.main__big-banner'),
			reviews: document.querySelector('.main-reviews'),
			articles: document.querySelector('.main-articles'),
			brands: document.querySelector('.main-brands'),
			catalog: document.querySelector('.home-top-goods'),
			advantages: document.querySelector('.main-card'),

		}
	},
	dropForMobile: function () {
		const elem = this.getMobile();

		if (elem.filter) elem.main.prepend(elem.filter);
		if (elem.bigBanner) elem.filter.after(elem.bigBanner);


		if (elem.banner) {
			elem.banner.querySelectorAll('.main-baner__wrap').forEach(function (item) {
				item.style.cssText = 'background-image: url("' + item.dataset.url + '")';
			});
		}

		if (elem.reviews) elem.reviews.insertAdjacentElement('beforeBegin', elem.articles);
		// if(elem.advantages)elem.advantages.insertAdjacentElement('beforeBegin', elem.popular);

		if (elem.advantages) {
			if (document.querySelectorAll('.create-popular').length < 1) {
				let temp = document.createElement('div');
				temp.classList.add('container');
				temp.classList.add('create-popular');
				elem.advantages.insertAdjacentElement('beforeBegin', temp);
				temp.append(elem.popular);
			}

		}
		if (elem.reviews) {
			document.querySelector('.main-articles__next').classList.add('disable');
			document.querySelector('.main-articles__prev').classList.add('disable');
		}
	},

	dropForDesktop: function () {
		const elem = this.getMobile();

		if (elem.banner) elem.main.prepend(elem.banner);
		if (elem.banner) {
			elem.banner.querySelectorAll('.main-baner__wrap').forEach(function (item) {
				item.style = '';
			});
		}
		if (elem.brands) elem.brands.insertAdjacentElement('beforeBegin', elem.reviews);
		// if(elem.articles)elem.articles.insertAdjacentElement('beforeBegin', elem.reviews);
		if (elem.popular) {
			if (document.querySelector('.create-popular')) document.querySelector('.create-popular').remove();
			if (document.querySelector('.filter__popular')) document.querySelector('.filter__popular').append(elem.popular);
		}



	},
	init: function () {
		this.makeClassificationHeight();
		this.buttons().forEach(item => {
			item.addEventListener('click', function () {
				if (item.closest(".main-classif__accardion").classList.contains('opened')) {
					window.k1ScriptHome.closeClassification(item);
				} else {
					window.k1ScriptHome.openClassification(item);
				}
			})
		})

	},

}

window.addEventListener('resize', () => {
	if (window.innerWidth <= 991) {
		window.k1ScriptHome.dropForMobile()
	} else {
		window.k1ScriptHome.dropForDesktop()
	}
})

if (window.innerWidth <= 991) {
	window.k1ScriptHome.dropForMobile()
} else {
	window.k1ScriptHome.dropForDesktop()
}

window.addEventListener('DOMContentLoaded', window.k1ScriptHome.init())







// makeSliderBannersHalf: function () {
// 	const swiper = new Swiper('.big-banner__slider.swiper-container', {

// 		// Optional parameters
// 		direction: 'horizontal',
// 		loop: true,
// 		slidesPerView: 2,
// 		speed: 700,
// 		slidesPerGroup: 2,
// 		spaceBetween: 20,
// 		// If we need pagination
// 		navigation: {
// 			nextEl: '.big-banner__next.swiper-button-next',
// 			prevEl: '.big-banner__prev.swiper-button-prev',
// 		},
// 		pagination: {
// 			el: '.swiper-pagination.big-banner__pagination',
// 			clickable: true
// 		},
// 	});
// },
// makeSliderReviews: function () {
// 	const swiper = new Swiper('.main-reviews__slider.swiper-container', {

// 		// Optional parameters
// 		direction: 'horizontal',
// 		loop: true,
// 		slidesPerView: 3,
// 		speed: 700,
// 		slidesPerGroup: 3,
// 		spaceBetween: 20,
// 		// If we need pagination
// 		pagination: {
// 			el: '.swiper-pagination.main-reviews__pagination',
// 			clickable: true
// 		},
// 		breakpoints: {
// 			320: {
// 				slidesPerView: 1,
// 				slidesPerGroup: 1,
// 			},
// 			768: {
// 				slidesPerView: 2,
// 				slidesPerGroup: 2,
// 			},
// 			991: {
// 				slidesPerView: 3,
// 				slidesPerGroup: 3,
// 			},
// 		}
// 	});
// },

// makeSliderArticles: function () {
// 	const swiper = new Swiper('.main-articles__slider.swiper-container', {

// 		// Optional parameters
// 		direction: 'horizontal',
// 		loop: true,
// 		slidesPerView: 3,
// 		speed: 700,
// 		slidesPerGroup: 3,
// 		spaceBetween: 20,
// 		// If we need pagination
// 		navigation: {
// 			nextEl: '.swiper-button-next.main-articles__next',
// 			prevEl: '.swiper-button-prev.main-articles__prev',
// 		},
// 		pagination: {
// 			el: '.swiper-pagination.main-articles__pagination',
// 			clickable: true
// 		},
// 		breakpoints: {
// 			320: {
// 				slidesPerView: 1.2,
// 				slidesPerGroup: 1,
// 			},
// 			560: {
// 				slidesPerView: 2,
// 				slidesPerGroup: 2,
// 			},
// 			991: {
// 				slidesPerView: 3,
// 				slidesPerGroup: 3,
// 			},
// 		}
// 	});
// },
// makeSliderBanners: function () {
// 	const swiper = new Swiper('.main-poster__slider.swiper-container', {

// 		// Optional parameters
// 		direction: 'horizontal',
// 		loop: true,
// 		slidesPerView: 1.05,
// 		speed: 700,
// 		spaceBetween: 10,
// 		// If we need pagination
// 		navigation: {
// 			nextEl: '.swiper-button-next.main-poster__next',
// 			prevEl: '.swiper-button-prev.main-poster__prev',
// 		},

// 		pagination: {
// 			el: '.swiper-pagination.main-poster__pagination',
// 			clickable: true
// 		},
// 	});
// },
// makeMainSliderBanners: function () {
// const swiper = new Swiper('.main-baner__slider.swiper-container', {

// 	// Optional parameters
// 	direction: 'horizontal',
// 	loop: true,
// 	slidesPerView: 1,
// 	speed: 700,
// 	spaceBetween: 0,
// 	// If we need pagination
// 	// navigation: {
// 	// 	nextEl: '.swiper-button-next.main-articles__next',
// 	// 	prevEl: '.swiper-button-prev.main-articles__prev',
// 	// },
// 	pagination: {
// 		el: '.swiper-pagination.main-baner__pagination',
// 		clickable: true
// 	},


// });
// },